// removed by extract-text-webpack-plugin
module.exports = {"box":"e6d9471718_src-housingCorporations-_EditLocationModal_box","bottom":"_6442f478e5_src-housingCorporations-_EditLocationModal_bottom","error":"_88b58d4902_src-housingCorporations-_EditLocationModal_error","dropZone":"_0f5481769a_src-housingCorporations-_EditLocationModal_dropZone","dropZoneActive":"_6af1a5dd29_src-housingCorporations-_EditLocationModal_dropZoneActive"};


//////////////////
// WEBPACK FOOTER
// ./src/housingCorporations/EditLocationModal.css
// module id = 172
// module chunks = 0